import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog'

interface AppAlertDialogProps {
  alertTriggerLabel?: string
  title: string
  description: React.ReactNode
  cancelLabel?: string
  actionLabel?: string
  onActionClick?: () => void
  onCancelClick?: () => void
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

export function AppAlertDialog({
  alertTriggerLabel,
  title,
  description,
  cancelLabel = 'Avbryt',
  actionLabel,
  open,
  onOpenChange,
  onActionClick,
  onCancelClick,
}: AppAlertDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      {alertTriggerLabel && <AlertDialogTrigger>{alertTriggerLabel}</AlertDialogTrigger>}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="border-b-0 pb-0 leading-normal font-family-font-sans">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="mt-0 leading-normal" asChild>
            <div>{description}</div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {onCancelClick && (
            <AlertDialogCancel onClick={onCancelClick} className="rounded-full">
              {cancelLabel}
            </AlertDialogCancel>
          )}
          {actionLabel && (
            <AlertDialogAction onClick={onActionClick} className="rounded-full">
              {actionLabel}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
